import React, { useState } from 'react';
import Icon from '../../../components/AppIcon';
import Image from '../../../components/AppImage';
import Button from '../../../components/ui/Button';

const UserResultCard = ({ user, onAddFriend, onMessage, onViewProfile }) => {
  const [friendshipStatus, setFriendshipStatus] = useState(user?.friendshipStatus);
  const [isLoading, setIsLoading] = useState(false);

  const handleAddFriend = async () => {
    setIsLoading(true);
    try {
      await onAddFriend(user?.id);
      setFriendshipStatus('pending');
    } catch (error) {
      console.error('Failed to send friend request:', error);
    } finally {
      setIsLoading(false);
    }
  };

  const handleMessage = () => {
    onMessage(user?.id);
  };

  const handleViewProfile = () => {
    onViewProfile(user?.id);
  };

  const renderActionButton = () => {
    switch (friendshipStatus) {
      case 'friends':
        return (
          <Button
            variant="outline"
            size="sm"
            onClick={handleMessage}
            iconName="MessageCircle"
            iconPosition="left"
            iconSize={16}
          >
            Message
          </Button>
        );
      case 'pending':
        return (
          <Button
            variant="secondary"
            size="sm"
            disabled
            iconName="Clock"
            iconPosition="left"
            iconSize={16}
          >
            Pending
          </Button>
        );
      case 'none':
      default:
        return (
          <Button
            variant="default"
            size="sm"
            onClick={handleAddFriend}
            loading={isLoading}
            iconName="UserPlus"
            iconPosition="left"
            iconSize={16}
          >
            Add Friend
          </Button>
        );
    }
  };

  return (
    <div className="flex items-center justify-between p-4 bg-card border border-border rounded-xl hover:shadow-elevation-1 transition-all duration-150 hover-lift">
      <div className="flex items-center space-x-4 flex-1 min-w-0">
        {/* Profile Image */}
        <button
          onClick={handleViewProfile}
          className="flex-shrink-0 hover-lift"
        >
          <div className="w-12 h-12 rounded-full overflow-hidden bg-muted">
            <Image
              src={user?.avatar}
              alt={user?.avatarAlt}
              className="w-full h-full object-cover"
            />
          </div>
        </button>

        {/* User Info */}
        <div className="flex-1 min-w-0">
          <button
            onClick={handleViewProfile}
            className="block text-left hover:underline"
          >
            <h3 className="font-semibold text-foreground truncate">
              {user?.name}
            </h3>
          </button>
          
          {user?.mutualFriends > 0 && (
            <p className="text-sm text-muted-foreground mt-1">
              {user?.mutualFriends} mutual friend{user?.mutualFriends !== 1 ? 's' : ''}
            </p>
          )}
          
          {user?.location && (
            <div className="flex items-center mt-1">
              <Icon name="MapPin" size={14} className="text-muted-foreground mr-1" />
              <span className="text-sm text-muted-foreground truncate">
                {user?.location}
              </span>
            </div>
          )}
        </div>
      </div>
      {/* Action Buttons */}
      <div className="flex items-center space-x-2 flex-shrink-0 ml-4">
        {renderActionButton()}
        
        <Button
          variant="ghost"
          size="sm"
          onClick={handleViewProfile}
          iconName="Eye"
          iconPosition="left"
          iconSize={16}
          className="hidden sm:flex"
        >
          View
        </Button>

        {/* Mobile View Profile Button */}
        <Button
          variant="ghost"
          size="icon"
          onClick={handleViewProfile}
          className="sm:hidden"
        >
          <Icon name="Eye" size={16} />
        </Button>
      </div>
    </div>
  );
};

export default UserResultCard;